<template>
    <div class="site-aside-container">
        <Avatar :url="data && data.avatar" />
        <Menu />
        <Contact />
    </div>
</template>

<script>
import Avatar from '../Avatar'
import Menu from '../Menu'
import Contact from '../Contact';
import { mapState } from 'vuex';
export default {
    components: {
        Avatar,
        Menu,
        Contact
    },
    computed: mapState('setting', ['data']),
    created() {
        this.$store.dispatch('setting/getData')
    }
}
</script>

<style lang="less" scoped>
.site-aside-container {
    background: #000;

    .avatar-container {
        padding-top: 50px;
    }

    .menu-container {
        padding-top: 40px;
    }

    .contact-container {
        padding-top: 100px;
    }
}
</style>